import script from "./ConfirmationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationDialog.vue?vue&type=style&index=0&id=55db32e4&lang=css"

const __exports__ = script;

export default __exports__